import styled from 'styled-components';
import { palette } from '../styles';

export const DeleteVacancyContainer = styled.div`
  padding: 0 72px;
  margin: 32px 0;
  font-family: 'Sofia Pro', sans-serif;
  min-height: 80vh;
  .title {
    margin: 20px;
    text-align: start;
    font-size: 1.7rem !important;
  }
  .filterContainer {
    width: 100%;
    label {
      margin: 20px;
      text-align: start;
      font-size: 1.7rem !important;
    }
    input {
      background-color: #f6faf9;
      font-family: 'Sofia Pro', sans-serif;
      font-size: 16px;
      border-radius: 30px;
      width: 40%;
      padding: 8px 32px;
    }
  }
  .subContainer {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  .vacancyCard {
    width: 90%;
    display: flex;
    padding: 10px;
    justify-content: space-between;
    align-items: center;
    margin: 25px auto;
    border-radius: 8px;
  }
  .cardContent {
    width: 80%;
    display: flex;
    justify-content: space-around;
    img {
      width: 18%;
      height: 120px;
    }
  }
  .dataContainer {
    display: flex;
    flex-direction: column;
    padding: 10px;
    width: 31%;
  }
  .jobTitle {
    font-size: 1.7rem !important;
    padding: 3px 0px;
    margin: 0px;
  }
  .companyName {
    font-size: 1.5rem !important;
    padding: 3px 0px;
    margin: 0px;
  }
  .contract {
    font-size: 1.7rem !important;
    padding: 3px 0px;
    margin: 0px;
  }
  .seeMore {
    font-size: 14px !important;
    color: #fff !important;
    background-color: ${(props) => (props.adminColor ? props.adminColor : '#22545b')};
    padding: 8px 12px;
    margin: 0px;
    font-weight: 600;
    cursor: pointer;
    border-radius: 8px;
  }
  .viewMore-btn {
    background-color: ${(props) => (props.adminColor ? props.adminColor : '#22545b')};
    width: 32px;
    height: 32px;
    border-radius: 8px;
    padding: 4px;
    position: absolute;
    top: -13px;
    right: 3.5%;
    box-shadow: 0 2.8px 2.2px rgba(0, 0, 0, 0.02), 0 6.7px 5.3px rgba(0, 0, 0, 0.028),
      0 12.5px 10px rgba(0, 0, 0, 0.035), 0 22.3px 17.9px rgba(0, 0, 0, 0.042), 0 41.8px 33.4px rgba(0, 0, 0, 0.05),
      0 100px 80px rgba(0, 0, 0, 0.07);
    &:hover {
      cursor: pointer;
    }
    svg {
      display: table;
      margin: 0 auto;
    }
  }
  .vacancyImage {
    width: 18%;
    height: 120px;
  }
  .cardAction {
    width: 20%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .deleteButton {
    padding: 8px 12px;
    font-size: 14px !important;
    color: ${palette.white};
    background: ${palette.red};
    width: 100%;
  }
  img {
    width: 256px;
    margin: 32px auto;
    display: table;
  }
  .job {
    position: relative;
    background: #e9e9e9;
    border: 0 solid rgba(0, 0, 0, 0.125);
    border-radius: 0.2rem;
    box-shadow: 0 5px 20px 0 rgb(0 0 0 / 15%);
    backface-visibility: hidden;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    transition: all ease-in-out 1s;
    transform: translateY(0);
    width: 100%;
    a {
      text-decoration: none !important;
      user-select: none;
      &:hover {
        cursor: pointer;
      }
    }
    p {
      font-size: 14px !important;
      margin-bottom: 12px;
    }
    h1 {
      font-size: 20px !important;
    }
    .job-image {
      position: relative;
      display: block;
      height: 250px;
      width: 100%;
      overflow: hidden;
      flex: 0 0 auto;
      background-size: cover;
      background-position: center center;
      background-repeat: no-repeat;
    }
    .job-content {
      background-color: #fff;
      position: relative;
      display: flex;
      flex-direction: column;
      flex: 1 1 auto;
      padding: 0 16px;
    }
    .job-base {
      position: relative;
      z-index: 2;
      background-color: #fff;
      padding: 64px 16px 24px 16px;
      flex: 0 0 auto;
      h3 {
        font-size: 20px !important;
        color: #0d5c1d;
        margin-bottom: 12px;
        font-family: 'Cooper Md BT', serif;
      }
      h4 {
        font-family: 'Sofia Pro', sans-serif;
        letter-spacing: 1px;
        font-weight: 400;
        font-size: 16px;
      }
    }
    .job-logo {
      display: block;
      background-color: #fff;
      box-shadow: rgb(0 0 0 / 8%) 0px 3px 10px;
      margin-right: 16px;
      position: absolute;
      top: -75px;
      left: 0;
      width: 100px;
      height: 100px;
      flex: 0 0 auto;
      border-radius: 8px;
      overflow: hidden;
      padding: 4px;
      img {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: contain;
        margin: 0;
      }
    }
    .ribbon-remote {
      background-color: #e2b469;
      position: absolute;
      right: 32px;
      top: 0;
      width: 32px;
      height: 50px;
      z-index: 99;
      border-bottom-left-radius: 16px;
      border-bottom-right-radius: 16px;
      box-shadow: rgb(0 0 0 / 8%) 0px 3px 10px;

      &__icon {
        position: absolute;
        top: 12px;
        left: 4px;
      }
    }
    .ribbon-ats {
      background-color: ${(props) => (props.adminColor ? props.adminColor : '#22545b')};
      position: absolute;
      right: ${(props) => (props.workType === 'Remoto' ? '73px' : '32px')};
      top: 0;
      width: 32px;
      height: 50px;
      z-index: 99;
      border-bottom-left-radius: 16px;
      border-bottom-right-radius: 16px;
      box-shadow: rgb(0 0 0 / 8%) 0px 3px 10px;
      &__icon {
        position: absolute;
        top: 12px;
        left: 4px;
      }
    }
  }
`;
export default null;
